var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dl', [_c('dt', {
    staticClass: "s-mb-3"
  }, [_vm._v(_vm._s(_vm.title))]), _c('dd', {
    staticClass: "s-text-xl s-text-gray-darker s-font-semibold",
    class: {
      's-mb-2': _vm.$slots.info
    }
  }, [_vm._t("default")], 2), _vm.$slots.info ? _c('small', {
    staticClass: "s-text-sm s-font-semibold"
  }, [_vm._t("info")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }